import { AEMErrorMessage } from '../../../models';

export const StatusErrorMessageMocks: AEMErrorMessage = {
  action: {
    label: 'What Is Million Miler?',
    url: '/us/en/skymiles/medallion-program/million-miler',
    id: 'levelStatusMillionMiler'
  },
  component: 'status',
  errorId: [
    {
      errorCode: 'CRD_5002'
    }
  ],
  errorMessageDescription:
    'Sorry, we’re currently unable to display your Lifetime Miles Flown.',
  errorMessageTitle: '',
  featureTitle: '',
  type: 'single-error'
};
